import { Button, Box, useTheme, alpha } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { MAIN_NAV_ITEMS } from '../config/navConfig';

const DesktopNav = ({ handleNavClick, currentPath }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ 
      flexGrow: 1, 
      display: { xs: "none", md: "flex" },
      ml: 4,
      gap: 2
    }}>
      {MAIN_NAV_ITEMS.map((item) => {
        const isActive = currentPath === item.path;
        
        return (
          <Button
            key={item.name}
            component={RouterLink}
            to={item.path}
            startIcon={item.icon}
            onClick={() => handleNavClick(item)}
            sx={{ 
              color: isActive ? 'secondary.main' : '#ffffff',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2.5,
              py: 0.75,
              borderRadius: 2,
              fontWeight: isActive ? 600 : 500,
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: theme => alpha(theme.palette.secondary.main, 0.08),
                transform: 'translateY(-2px)',
              },
              '&::after': isActive ? {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '10%',
                width: '80%',
                height: 3,
                borderRadius: '3px 3px 0 0',
                backgroundColor: 'secondary.main',
              } : {},
            }}
          >
            {item.name}
          </Button>
        );
      })}
    </Box>
  );
};

export default DesktopNav;